import gsap from 'gsap';
import focusTrap from 'focus-trap';
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import { on } from '@src/utils';
import { KEY_CODES } from '@src/utils/constants';

gsap.defaults({
  duration: 0.3,
  ease: 'power3.inOut',
});

const SHOW = { autoAlpha: 1, pointerEvents: 'initial' };
const HIDE = { autoAlpha: 0, pointerEvents: 'none' };

class VideoModal {
  constructor(element) {
    this.playButton = element.querySelector('.js-play-button');
    if (this.playButton) {
      this.modal = element.querySelector('.js-video-modal');

      this.embed = this.modal.querySelector('.js-video-embed');

      this.iframe = this.modal.querySelector('iframe');
      this.iframe.tabIndex = 0;
      this.iframeSrc = this.iframe.src;

      this.closeButton = this.modal.querySelector('.js-close-button');
      this.focusTrap = focusTrap(this.modal);

      this.listeners = [];

      this.bindEvents();
      gsap.set([this.modal, this.embed], HIDE);
    }
  }

  bindEvents() {
    this.playButton.addEventListener('click', () => this.open());
    this.closeButton.addEventListener('click', () => this.close());
  }

  close() {
    enableBodyScroll(this.modal);
    this.closeAnim(this.modal, this.embed);
    this.listeners.forEach(off => {
      off();
    });
    this.iframe.src = '';
    this.focusTrap.deactivate();
  }

  open() {
    disableBodyScroll(this.modal);
    this.closeButton.focus();
    this.listeners.push(on(document, 'keydown', this.keydown.bind(this)));
    this.iframe.src = this.iframeSrc;
    this.iframe.src += '&autoplay=1';
    this.openAnim(this.modal, this.embed);
  }

  openAnim(modal, embed) {
    this.tl = gsap.timeline();
    this.tl
      .to(modal, SHOW)
      .set(['.nav', '.program-content__nav.js-page-nav-bar', '.footer'], { zIndex: 0 }, '<')
      .to(embed, SHOW)
      .call(() => this.focusTrap.activate());
  }

  closeAnim(modal, embed) {
    this.tl = gsap.timeline();
    this.tl
      .to(embed, HIDE)
      .to(modal, HIDE, '<')
      .set(['.nav', '.program-content__nav.js-page-nav-bar', '.footer'], { clearProps: 'all' });
  }

  keydown(e) {
    if (e.keyCode === KEY_CODES.ESCAPE) {
      this.close();
    }
  }
}

export default VideoModal;
